import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getAllBillsByMes = createAsyncThunk(
  "gastos/getAllBillsByMes",
  async (payload) => {
    const response = await axios
      .get(
        `https://yourbillsbackend-production.up.railway.app/api/Bills/all?usuarioId=${payload.usuarioId}`,
        {
          headers: {
            Authorization: `bearer ${
              JSON.parse(localStorage.getItem("userCredentials")).token
            }`,
          },
        }
      )
      .then((response) => response.data)
      .catch(({ response }) => ({ ...response.data }));
    return response;
  }
);
export const deletedBills = createAsyncThunk(
  "gastos/deletedBills",
  async (payload) => {
    console.log(payload);
    const response = await axios.delete(
      "https://yourbillsbackend-production.up.railway.app/api/Bills/delete",
      {
        data: payload,
      }
    );
    return response.data;
  }
);
export const postBills = createAsyncThunk(
  "gastos/postBills",
  async (payload) => {
    const response = await axios
      .post(
        `https://yourbillsbackend-production.up.railway.app/api/Bills/add`,
        payload
      )
      .then((response) => response.data)
      .catch(({ response }) => ({ ...response.data }));
    return response;
  }
);
const initialState = {
  mygastos: [],
};
const gastosSlice = createSlice({
  name: "gastos",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllBillsByMes.pending, (state) => {
        console.log("trayendo");
      })
      .addCase(getAllBillsByMes.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload.error || action.payload === null) {
          return initialState;
        }
        let newGastos = state.mygastos;
        newGastos = action.payload;
        state.mygastos = newGastos;
      })
      .addCase(postBills.pending, (state) => {
        console.log("enviando");
      });
  },
});
export default gastosSlice.reducer;
export const Mygastos = (state) => state.gastos.mygastos;
